// T3-B sponsored motif (PR 7-CMS, 2026-05-07): 効果計測 endpoint client。
// api 側 implementation: omikuji-api PR #99 (PR 7-API)。
//
// auth: ADMIN only。

import ApiService from './ApiService';

export default class SponsoredCampaignStatsApi extends ApiService {
    // GET /system/sponsored-campaigns/:id/stats?from=YYYY-MM-DD&to=YYYY-MM-DD
    getCampaignStats(payload: { id: string | number, from?: string, to?: string }) {
        const { id, from, to } = payload;
        const params: Record<string, string> = {};
        if (from) params.from = from;
        if (to) params.to = to;
        return this.get(`sponsored-campaigns/${id}/stats`, params);
    }
}
